<template>
  <div class="py-4 d-flex justify-space-between align-center secondary">
    <v-btn
      class="pl-0"
      color="primary"
      :disabled="!(page - 1 >= 1)"
      text
      @click="prev"
    >
      <v-icon>mdi-menu-left</v-icon>
      <p class="text-body-2">
        Previous Page
      </p>
    </v-btn>
    <v-btn
      class="pr-0"
      color="primary"
      :disabled="!(page + 1 <= numberOfPages)"
      text
      @click="next"
    >
      <p class="text-body-2">
        Next Page
      </p>
      <v-icon>mdi-menu-right</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { DEFAULT_PAGE_SIZE } from '@/utils/constants'

export default {
  name: 'BasePaginator',

  props: {
    /** Current page number */
    page: {
      type: Number,
      required: true,
    },
    /** Total items per page */
    total: {
      type: Number,
      required: true,
    },
    /** Total items per page */
    itemsPerPage: {
      type: Number,
      default: DEFAULT_PAGE_SIZE,
    },
  },

  computed: {
    numberOfPages: function() {
      return Math.ceil(this.total / this.itemsPerPage)
    },
  },

  methods: {
    next() {
      if (this.page + 1 <= this.numberOfPages) {
        this.$emit('change', this.page + 1)
      }
    },

    prev() {
      if (this.page - 1 >= 1) {
        this.$emit('change', this.page - 1)
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
